export default "__VITE_PUBLIC_ASSET__50558e8d__"